module.exports = __webpack_public_path__ + "assets/b72.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b72.png
// module id = 663
// module chunks = 0